import FingerprintJS from '@fingerprintjs/fingerprintjs';

import { encryptString } from './encryptor';

const getDeviceFingerprint = async () => {
  const fp = await FingerprintJS.load();
  const result = await fp.get();
  const encryptedVisitorId = await encryptString(result.visitorId);
  return encryptedVisitorId;
};

export default getDeviceFingerprint;
